import { render } from "./ListeTransfertMagasinPage.vue?vue&type=template&id=d17bd2b2&ts=true"
import script from "./ListeTransfertMagasinPage.vue?vue&type=script&lang=ts"
export * from "./ListeTransfertMagasinPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__